import React from "react";
import { Link, useParams } from "react-router-dom-v5-compat";
import { useTranslation } from "react-i18next";
import { Title, ContentBox, Button } from "./Atoms";

const PaymentSuccess = () => {
  const { t } = useTranslation();
  return (
    <div className="space-y-16">
      <ContentBox className="space-y-16">
        <Title>{t("onlinePayments.paymentConfirmed")}</Title>
        <div className="text-neutral-600">{t("onlinePayments.thankYou")}</div>
      </ContentBox>
      <div className="text-xs">
        {t("onlinePayments.requestTaxInvoiceFromStaffMember")}
      </div>
    </div>
  );
};

const PaymentCancelled = () => {
  const { t } = useTranslation();
  return (
    <ContentBox className="space-y-16">
      <Title>{t("onlinePayments.paymentCancelled")}</Title>
      <div className="text-neutral-600">
        {t("onlinePayments.settleYourBill")}
      </div>
    </ContentBox>
  );
};

export const TabPaymentStatus = () => {
  const { t } = useTranslation();
  const { status } = useParams();
  const paymentSuccess = status === "success";

  return (
    <div className="flex-col items-stretch text-center space-y-32 mx-48">
      {paymentSuccess ? <PaymentSuccess /> : <PaymentCancelled />}
      <Button tag={Link} to="../../">
        {t("onlinePayments.returnToYourOrder")}
      </Button>
    </div>
  );
};
